import { useState, useEffect } from 'react'
import { getIncomeShiftFlatrateTypeAPI } from '../services/in-come'

function UseIncomeShiftFlatrateType() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getIncomeShiftFlatrateTypeAPI()
      if (!resp) return
      if (resp.status) {
        setData(
          resp.result.map((d) => ({
            label: d.shiftFlatRate,
            value: d.shiftFlatRateId
          }))
        )
      }
    }
    getData()
  }, [])

  return data
}

export default UseIncomeShiftFlatrateType
